import React from "react";

const IconSearch = ({
  fill = "none",
  stroke = "currentColor",
  width = "15",
  height = "15",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="vuesax/linear/search-normal">
      <g id="search-normal">
        <path
          id="Vector"
          d="M7.1875 13.625C10.4667 13.625 13.125 10.9667 13.125 7.6875C13.125 4.40831 10.4667 1.75 7.1875 1.75C3.90831 1.75 1.25 4.40831 1.25 7.6875C1.25 10.9667 3.90831 13.625 7.1875 13.625Z"
          stroke={stroke}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M13.75 14.25L12.5 13"
          stroke={stroke}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default IconSearch;
